import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  Grid,
  Divider,
  MenuItem,
  TextField,
  Typography,
  TextareaAutosize,
  Table,
} from "@mui/material";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState } from "react";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import CustomLabel from "../../../CustomLable";
import api from "../../../utils/Url";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { getISTDate } from "../../../utils/Constant";
import Languages from "../../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../TranslateTextField";
import api2 from "../../../utils/Url2";


type Props = {};

const mrnTypeOption = [
  { value: "IOT", label: "IOT" },
  { value: "GSM", label: "GSM" },
  { value: "LTE", label: "LTE" },
  { value: "CDMA", label: "CDMA" },
];


const VehicleDetailEdit = (props: Props) => {
  let navigate = useNavigate();
  const { t } = useTranslation();
  const { defaultValues } = getISTDate();
  const [lang, setLang] = useState<Language>("en");
  const location = useLocation();
  const [toaster, setToaster] = useState(false);
  const [vendorData, setVendorData] = useState([]);
  const [vendorDetail, setVendorDetail] = useState<any>();
  const initialRowData = {

  };
  const [vehicleOption, setvehicleOption] = useState([
    { value: -1, label: t("text.vehicleTypeId") },
  ]);

  const [brandOption, setbrandOption] = useState([
    { value: -1, label: t("text.brandId") },
  ]);

  const [fuelTypeOption, setfuelTypeOption] = useState([
    { value: -1, label: t("text.fuelTypeId") },
  ]);

  const [taxOption, settaxOption] = useState([
    { value: -1, label: t("text.taxId") },
  ]);

  const [unitOption, setunitOption] = useState([
    { value: -1, label: t("text.unitId") },
  ]);

  const [zoneOption, setzoneOption] = useState([
    { value: -1, label: t("text.zoneID") },
  ]);

  const [categoryOption, setcategoryOption] = useState([
    { value: -1, label: t("text.itemCategoryId") },
  ]);

  const [empOption, setempOption] = useState([
    { value: -1, label: t("text.empid") },
  ]);

  const [deviceOption, setdeviceOption] = useState([
    { value: -1, label: t("text.id") },
  ]);

  const [v1Option, setv1Option] = useState([
    { value: -1, label: t("text.itemTypeMasterId") },
  ]);

  const [departmentOption, setdepartmentOption ] = useState([
    { value: -1, label: t("text.departmentId") },
  ]);
  const [designationOption, setdesignationOption ] = useState([
    { value: -1, label: t("text.designationId") },
  ]);

  useEffect(() => {
    getVehicleData();
    getbrandData();
    getfuelTypeData();
    gettaxData();
    getunitData();
    getzoneData();
    getcategoryData();
    getempData();
    getdeviceData();
    getdepartmentData();
    getdesignationData();
    getv1Data();
  }, []);

  const getVehicleData = async () => {
    const collectData = {
      "vehicleTypeId": -1,
      "vehicleTypename": ""
    };
    const response = await api.post(`VehicleType/GetVehicleType`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["vehicleTypename"],
        value: data[index]["vehicleTypeId"],
      });
    }
    setvehicleOption(arr);
  };

  const getbrandData = async () => {
    const collectData = {
      "brandId": -1,
      "brandname": "",
      "brandshortname": "",
      "brandCode": "",
      "createdBy": ""
    };
    const response = await api.post(`Brand/GetBrand`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["brandname"],
        value: data[index]["brandId"],
      });
    }
    setbrandOption(arr);
  };

  const getfuelTypeData = async () => {
    const collectData = {
      "fuelTypeId": -1,
      "fuelTypename": ""
    };
    const response = await api.post(`FuelType/GetFuelType`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["fuelTypename"],
        value: data[index]["fuelTypeId"],
      });
    }
    setfuelTypeOption(arr);
  };

  const gettaxData = async () => {
    const collectData = {
      "taxId": -1,
    };
    const response = await api.post(`TaxMaster/GetTaxMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["taxName"],
        value: data[index]["taxId"],
      });
    }
    settaxOption(arr);
  };


  const getunitData = async () => {
    const collectData = {
      "unitId": -1,
    };
    const response = await api.post(`UnitMaster/GetUnitMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["unitName"],
        value: data[index]["unitId"],
      });
    }
    setunitOption(arr);
  };

  const getzoneData = async () => {
    const collectData = {
      "zoneID": -1,
      "user_ID": "",
      "isActive": true
    };
    const response = await api.post(`Zone/GetZonemaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["zoneName"],
        value: data[index]["zoneID"],
      });
    }
    setzoneOption(arr);
  };

  const getcategoryData = async () => {
    const collectData = {
      "orderby": "",
      "pageNo": 0,
      "pageSize": 0,
      "intnotnullvalue1": 0,
      "userId": "",
      "str1": "",
      "str2": "",
      "str3": "",
      "str4": "",
      "str5": "",
      "flag": true,
      "data": "",
      "success": true,
      "error": "",
      "selectPerindex": 0,
      "show": true
    };
    const response = await api.post(`ItemCategory/GetItemCategory`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["itemCategory"],
        value: data[index]["itemCategoryId"],
      });
    }
    setcategoryOption(arr);
  };

  const getempData = async () => {
    const collectData = {
      "orderby": "",
      "pageNo": 0,
      "pageSize": 0,
      "intnotnullvalue1": 0,
      "userId": "",

      "str1": "",
      "str2": "",
      "str3": "",
      "str4": "",
      "str5": "",
      "intvalue1": 0,
      "intvalue2": 0,
      "intvalue3": 0,
      "intvalue4": 0,
      "intnotnullvalue2": 0,
      "intnotnullvalue3": 0,
      "dec1": 0,
      "dec2": 0,
      "dec3": 0,
      "dec4": 0,
      "flag": true,
      "data": "",
      "success": true,
      "error": "",
      "selectPerindex": 0,
      "show": true
    };
    const response = await api.post(`Employee/GetEmployee`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["empName"],
        value: data[index]["empid"],
      });
    }
    setempOption(arr);
  };

  const getv1Data = async () => {
    const collectData = {
      "itemTypeMasterId": -1,
    };
    const response = await api.post(`ItemTypeMaster/GetItemTypeMaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["itemType"],
        value: data[index]["itemTypeMasterId"],
      });
    }
    setv1Option(arr);
  };

  const getdeviceData = async () => {
    const collectData = {
      "orderby": "",
      "pageNo": 0,
      "pageSize": 0,
      "intnotnullvalue1": 0,
      "userId": "",

      "str1": "",
      "str2": "",
      "str3": "",
      "str4": "",
      "str5": "",
      "intvalue1": 0,
      "intvalue2": 0,
      "intvalue3": 0,
      "intvalue4": 0,
      "intnotnullvalue2": 0,
      "intnotnullvalue3": 0,
      "date1": defaultValues,
      "date2": defaultValues,
      "date3": defaultValues,
      "date4": defaultValues,
      "dec1": 0,
      "dec2": 0,
      "dec3": 0,
      "dec4": 0,
      "flag": true,
      "data": "",
      "success": true,
      "error": "",
      "selectPerindex": 0,
      "show": true

    };
    const response = await api.post(`DeviceType/GetDeviceType`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["dtype"],
        value: data[index]["id"],
      });
    }
    setdeviceOption(arr);
  };
console.log(location.state.serialNo);
  const getdepartmentData = async () => {
    const collectData = {
      "departmentId": -1,
      "departmentName": ""
    };
    const response = await api.post(`Department/GetDepartmentmaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["departmentName"],
        value: data[index]["departmentId"],
      });
    }
    setdepartmentOption(arr);
  };

  const getdesignationData = async () => {
    const collectData = {
      "designationId": -1,
      
    };
    const response = await api.post(`Designation/GetDesignationmaster`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["designationName"],
        value: data[index]["designationId"],
      });
    }
    setdesignationOption(arr);
  };


  const formik = useFormik({
    initialValues: {
      activeClass: location.state?.activeClass || "",
      all: location.state?.all || true,
      showExisting: location.state?.showExisting || true,
      isSuccess: location.state?.isSuccess || true,
      message: location.state?.message || "",
      srno: location.state?.srno || 0,
      eScarp: location.state?.eScarp || true,
      eScarpPrevValue: location.state?.eScarpPrevValue || "",
      css: location.state?.css || "",
      itemMasterId: location.state?.itemMasterId || 0,
      itemName: location.state?.itemName || "",
      itemCode: location.state?.itemCode || "",
      itemTypeId: location.state?.itemTypeId || 0,
      itemFlag: location.state?.itemFlag || "",
      itemCategoryId: location.state?.itemCategoryId || 0,
      unitId: location.state?.unitId || 0,
      empId: location.state?.empId || 0,
      taxId: location.state?.taxId || 0,
      purchaseYear: location.state?.purchaseYear || 0,
      modelNo: location.state?.modelNo || "",
      serialNo: location.state?.serialNo || "",

      vehicleNo: location.state?.vehicleNo || "",
      vZoneID: location.state?.vZoneID || 0,
      hsnCode: location.state?.hsnCode || "",
      chesisNo: location.state?.chesisNo || "",
      qcApplicable: location.state?.qcApplicable || true,
      depreciationRate: location.state?.depreciationRate || 0,
      createdBy: location.state?.createdBy || "",
      updatedBy: location.state?.updatedBy || "",
      devid: location.state?.devid || "",
      existDevid: location.state?.existDevid || "",
      simNo: location.state?.simNo || "",
      simCompany: location.state?.simCompany || "",
      simType: location.state?.simType || "",
      deviceTypeId: location.state?.deviceTypeId || 0,
      existSimNo: location.state?.existSimNo || "",
      devidRemark: location.state?.devidRemark || "",
      simNoRemark: location.state?.simNoRemark || "",
      seviceEnggCode: location.state?.seviceEnggCode || "",
      simContactNo: location.state?.simContactNo || "",
      gpsType: location.state?.gpsType || "",
      gpsid: location.state?.gpsid || "",
      workType: location.state?.workType || "",
      replacement: location.state?.replacement || "",
      repair: location.state?.repair || true,
      zoneName: location.state?.zoneName || "",
      createdOn: location.state?.createdOn || defaultValues,
      updatedOn: location.state?.updatedOn || defaultValues,
      mileage: location.state?.mileage || 0,
      litrePerHr: location.state?.litrePerHr || 0,
      kmPerLitre: location.state?.kmPerLitre || 0,
      fuelAlloted: location.state?.fuelAlloted || 0,
      srn: location.state?.srn || 0,
      vehicleTypeId: location.state?.vehicleTypeId || 0,
      brandTypeId: location.state?.brandTypeId || 0,
      fuelTypeId: location.state?.fuelTypeId || 0,
      ntRecord: location.state?.ntRecord || "",
      vehicleWeight: location.state?.vehicleWeight || 0,
      departmentName: location.state?.departmentName || "",
      designationName: location.state?.designationName || "",
      rfid: location.state?.rfid || "",
      rfid2: location.state?.rfid2 || "",
      deptId: location.state?.deptId || 0,
      desigId: location.state?.desigId || 0
    },

    validationSchema: Yup.object({
         hsnCode: Yup.string()
           .required(t("text.reqHSNCode")),
         vehicleNo: Yup.string()
           .required(t("text.reqVehicleNum")),
         simNo: Yup.string()
           .required(t("text.reqSimNum")),
           modelNo: Yup.string()
           .required(t("text.reqModelNo")),
       }),
   
    

    onSubmit: async (values) => {
      // values.vendor = vendorDetail;

      const response = await api.post(`ItemMaster/AddUpdateItemMaster`, values);
      if (response.data.status === 1) {
        setToaster(false);
        toast.success(response.data.message);
        navigate("/vehiclemanagement/vehicledetail");
      } else {
        setToaster(true);
        toast.error(response.data.message);
      }
    },
  });

  const back = useNavigate();

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          border: ".5px solid #FF7722",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.VehicleDetailEdit")}
          </Typography>
          <Grid container justifyContent="flex-end">
            <Grid item lg={2} md={2} xs={12} marginTop={2}>
              <select
                className="language-dropdown"
                value={lang}
                onChange={(e) => setLang(e.target.value as Language)}
              >
                {Languages.map((l) => (
                  <option key={l.value} value={l.value}>
                    {l.label}
                  </option>
                ))}
              </select>
            </Grid>
          </Grid>
          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={zoneOption}
                  value={
                    zoneOption.find(
                      (option) =>
                        option.value ==
                        formik.values.vZoneID
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    formik.setFieldValue("vZoneID", newValue?.value.toString());
                    formik.setFieldValue("zoneName", newValue?.label);
                  }}
                  // value={formik.values.tamplateId}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.SelectZone")} required={false} />}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.VehicleName")}
                  value={formik.values.itemName}
                  onChangeText={(text: string) => formik.setFieldValue("itemName", text)}
                  required={false}
                  lang={lang}
                // placeholder={t("text.VehicleName")}
                />
                {formik.touched.itemName && formik.errors.itemName ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {/* {formik.errors.itemName} */}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={<CustomLabel text={t("text.EnterCode")} required={false} />}
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="itemCode"
                  id="itemCode"
                  placeholder={t("text.EnterCode")}
                  value={formik.values.itemCode}
                  onChange={formik.handleChange}
                />
                {formik.touched.itemCode && formik.errors.itemCode ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {/* {formik.errors.itemCode} */}
                  </div>
                ) : null}
              </Grid>


              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.HsnCode")}
                  value={formik.values.hsnCode}
                  onChangeText={(text: string) => formik.setFieldValue("hsnCode", text)}
                  required={false}
                  lang={lang}
                // placeholder={t("text.VehicleName")}
                />
                {formik.touched.hsnCode && formik.errors.hsnCode ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {/* {formik.errors.itemName} */}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={categoryOption}
                  value={
                    categoryOption.find(
                      (option) =>
                        option.value ==
                        formik.values.itemCategoryId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    formik.setFieldValue("itemCategoryId", newValue?.value.toString());
                    formik.setFieldValue("itemCategory", newValue?.label);
                  }}
                  // value={formik.values.tamplateId}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.Category")} required={false} />}
                    />
                  )}
                />
              </Grid>

            

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={v1Option}
                  value={
                    v1Option.find(
                      (option) =>
                        option.value ==
                        formik.values.itemTypeId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    formik.setFieldValue("itemTypeId", newValue?.value.toString());
                    formik.setFieldValue("itemType", newValue?.label);
                  }}
                  // value={formik.values.tamplateId}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.VehicleTypeName")} required={false} />}
                    />
                  )}
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={unitOption}
                  value={
                    unitOption.find(
                      (option) =>
                        option.value ==
                        formik.values.unitId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    formik.setFieldValue("unitId", newValue?.value.toString());
                    formik.setFieldValue("unitName", newValue?.label);
                  }}
                  // value={formik.values.tamplateId}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.EnterUnit")} required={false} />}
                    />
                  )}
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={taxOption}
                  value={
                    taxOption.find(
                      (option) =>
                        option.value ==
                        formik.values.taxId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    formik.setFieldValue("taxId", newValue?.value.toString());
                    formik.setFieldValue("taxName", newValue?.label);
                  }}
                  // value={formik.values.tamplateId}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.Tax")} required={false} />}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.entermodelNo")}
                  value={formik.values.modelNo}
                  onChangeText={(text: string) => formik.setFieldValue("modelNo", text)}
                  required={true}
                  lang={lang}
                />
                {formik.touched.modelNo && formik.errors.modelNo ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.modelNo)}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.entervehicleNo")}
                  value={formik.values.vehicleNo}
                  onChangeText={(text: string) => formik.setFieldValue("vehicleNo", text)}
                  required={true}  // Set required to true
                  lang={lang}
                />
                {formik.touched.vehicleNo && formik.errors.vehicleNo ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {/* {formik.errors.vehicleNo} */}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.SimNo")}
                  value={formik.values.simNo} // Ensure this is pointing to the correct state
                  onChangeText={(text: string) => formik.setFieldValue("simNo", text)} // This should correctly update Formik's state
                  required={true} // Ensure this is set to true if the field is required
                  lang={lang}
                />
                {formik.touched.simNo && formik.errors.simNo ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {/* {formik.errors.simNo} */}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={mrnTypeOption}
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    formik.setFieldValue("simType", newValue?.value.toString());
                  }}
                  value={formik.values.simType}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.SimType")} required={false} />}
                    />
                  )}
                />
              </Grid>


              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.SimCompanyName")}
                  value={formik.values.simCompany}
                  onChangeText={(text: string) => formik.setFieldValue("simCompany", text)}
                  required={false}
                  lang={lang}
                // placeholder={t("text.SimCompanyName")}
                />
                {formik.touched.simCompany && formik.errors.simCompany ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {/* {formik.errors.simCompany} */}
                  </div>
                ) : null}
              </Grid>

              {/* <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={<CustomLabel text={t("text.SerialNo")} required={false} />}
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="serialNo"
                  id="serialNo"
                  placeholder={t("text.SerialNo")}
                  value={formik.values.serialNo.toString()}
                  onChange={formik.handleChange}
                />

                {formik.touched.serialNo && formik.errors.serialNo ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {/* {formik.errors.itemCode} */}
                  {/* </div>
                ) : null}
              </Grid> */} 



              <Grid item xs={12} sm={4} lg={4}>
              <TranslateTextField
  label={t("text.SerialNo")}
  value={formik.values.serialNo}
  onChangeText={(text: string) => formik.setFieldValue("serialNo", text.toString())}
  required={false}
  lang={lang}
/>

                {formik.touched.serialNo && formik.errors.serialNo ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {/* {formik.errors.simCompany} */}
                  </div>
                ) : null}
              </Grid>
              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={<CustomLabel text={t("text.ChasisNo")} required={false} />}
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="chesisNo"
                  id="chesisNo"
                  placeholder={t("text.ChasisNo")}
                  value={formik.values.chesisNo}
                  onChange={formik.handleChange}
                />
                {formik.touched.chesisNo && formik.errors.chesisNo ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {/* {formik.errors.itemCode} */}
                  </div>
                ) : null}
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={<CustomLabel text={t("text.enterpurchaseYear")} required={false} />}
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="purchaseYear"
                  id="purchaseYear"
                  placeholder={t("text.enterpurchaseYear")}
                  value={formik.values.purchaseYear}
                  onChange={formik.handleChange}
                />
                {formik.touched.purchaseYear && formik.errors.purchaseYear ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {/* {formik.errors.itemCode} */}
                  </div>
                ) : null}
              </Grid>

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={empOption}
                  value={
                    empOption.find(
                      (option: any) =>
                        option.value ==
                        formik.values.empId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    formik.setFieldValue("empid", newValue?.value.toString());
                    formik.setFieldValue("empName", newValue?.label);
                  }}
                  // value={formik.values.tamplateId}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.UnderControlOF")} required={false} />}
                    />
                  )}
                />
              </Grid>

             

              
              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={departmentOption}
                  
                  value={
                    departmentOption.find(
                      (option: any) =>
                        option.value ==
                        formik.values.deptId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event:any, newValue:any) => {
                    console.log(newValue?.value);
                     formik.setFieldValue("deptId", newValue?.value.toString());
                    formik.setFieldValue("departmentName", newValue?.label);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.EnterDepartment")} />}
                    />
                  )}
                />
              </Grid>

        
              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={designationOption}
                  value={
                    designationOption.find(
                      (option) =>
                        option.value ==
                        formik.values.desigId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    formik.setFieldValue("desigId", newValue?.value.toString());
                    formik.setFieldValue("designationName", newValue?.label);
                  }}
                  // value={formik.values.tamplateId}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.Designation1")} required={false} />}
                    />
                  )}
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={vehicleOption}
                  value={
                    vehicleOption.find(
                      (option: any) =>
                        option.value ==
                        formik.values.vehicleTypeId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    formik.setFieldValue("vehicleTypeId", newValue?.value.toString());
                    formik.setFieldValue("VehicleTypeName", newValue?.label);
                  }}
                  // value={formik.values.tamplateId}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.VehicleTypeName")} required={false} />}
                    />
                  )}
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={brandOption}
                  value={
                    brandOption.find(
                      (option: any) =>
                        option.value ==
                        formik.values.brandTypeId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    formik.setFieldValue("brandTypeId", newValue?.value.toString());
                    formik.setFieldValue("brandname", newValue?.label);
                  }}
                  // value={formik.values.tamplateId}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.BrandType")} required={false} />}
                    />
                  )}
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={fuelTypeOption}
                  value={
                    fuelTypeOption.find(
                      (option: any) =>
                        option.value ==
                        formik.values.fuelTypeId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    formik.setFieldValue("fuelTypeId", newValue?.value.toString());
                    formik.setFieldValue("fuelTypename", newValue?.label);
                  }}
                  // value={formik.values.tamplateId}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.FuelType")} required={false} />}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.Weight")}
                  value={formik.values.vehicleWeight !== undefined ? String(formik.values.vehicleWeight) : ''} // Convert number to string for input
                  onChangeText={(text: string) => {
                    const parsedValue = Number(text);
                    if (!isNaN(parsedValue)) { // Check if the input is a valid number
                      formik.setFieldValue("vehicleWeight", parsedValue);
                    }
                  }}
                  required={true} // Set required to true
                  lang={lang}
                // placeholder={t("text.Weight")}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.LitrePerHour")}
                  value={formik.values.litrePerHr.toString()} // Keep this as a number
                  onChangeText={(text: string) => {
                    const numberValue = parseFloat(text); // Convert text to a number
                    if (!isNaN(numberValue)) {
                      formik.setFieldValue("litrePerHr", numberValue); // Set the value as a number
                    } else {
                      formik.setFieldValue("litrePerHr", ''); // Optionally handle invalid input
                    }
                  }}
                  required={false}
                  lang={lang}
                // placeholder={t("text.LitrePerHour")}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.KMperLitre")}
                  value={formik.values.kmPerLitre.toString()} // Keep this as string for display
                  onChangeText={(text: string) => {
                    const value = parseFloat(text); // Convert the input text to a number
                    if (!isNaN(value)) { // Check if the conversion was successful
                      formik.setFieldValue("kmPerLitre", value); // Set the value as a number
                    } else {
                      formik.setFieldValue("kmPerLitre", ''); // Optionally handle invalid input
                    }
                  }}
                  required={false}
                  lang={lang}
                // placeholder={t("text.KMperLitre")}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.DeviceNo")}
                  value={formik.values.devid}
                  onChangeText={(text: string) => formik.setFieldValue("devid", text)}
                  required={false}
                  lang={lang}
                // placeholder={t("text.DeviceNo")}
                />
              </Grid>

              <Grid item lg={4} xs={12}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={deviceOption}
                  value={
                    deviceOption.find(
                      (option: any) =>
                        option.value ==
                        formik.values.deviceTypeId
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event: any, newValue: any) => {
                    formik.setFieldValue("deviceTypeId", newValue?.value.toString());
                    formik.setFieldValue("dtype", newValue?.label);
                  }}
                  // value={formik.values.tamplateId}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.DeviceType")} required={false} />}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.RFID1")}
                  value={formik.values.rfid}
                  onChangeText={(text: string) => formik.setFieldValue("rfid", text)}
                  required={false}
                  lang={lang}
                // placeholder={t("text.RFID1")}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.RFID2")}
                  value={formik.values.rfid2}
                  onChangeText={(text: string) => formik.setFieldValue("rfid2", text)}
                  required={false}
                  lang={lang}
                // placeholder={t("text.RFID2")}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TranslateTextField
                  label={t("text.AllotedFuel")}
                  value={formik.values.fuelAlloted?.toString() || ''} // Convert number to string for display
                  onChangeText={(text: string) => {
                    const numberValue = parseFloat(text); // Convert string to number
                    if (!isNaN(numberValue)) {
                      formik.setFieldValue("fuelAlloted", numberValue); // Set the value as a number
                    } else {
                      formik.setFieldValue("fuelAlloted", ''); // Reset if not a valid number
                    }
                  }}
                  required={false}
                  lang={lang}
                />
              </Grid>

              <Grid item lg={12} xs={12}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={formik.values.eScarp}
                        onChange={formik.handleChange}
                        name="eScarp"
                      />
                    }
                    label={t("text.SaveEscrapAlso")}
                  />
                </FormGroup>
              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  style={{
                    backgroundColor: `var(--header-background)`,
                    color: "white",
                    marginTop: "10px",
                  }}
                >
                  {t("text.update")}
                </Button>
              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  onClick={(e: any) => formik.resetForm()}
                >
                  {t("text.reset")}
                </Button>
              </Grid>

            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default VehicleDetailEdit;